import React, { ReactNode } from 'react';
import { TableFormContext } from '@/context/TableFormContext';

interface TableFormProviderProps {
    editInForm?: boolean;
    viewInForm?: boolean;
    children: ReactNode;
}

export const TableFormProvider: React.FC<TableFormProviderProps> = ({
    editInForm = false,
    viewInForm = false,
    children,
}) => {
    return <TableFormContext value={{ editInForm: editInForm, viewInForm: viewInForm }}>{children}</TableFormContext>;
};
